/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-07.
 * Allow to user edit fields inline
 */
import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import DatePicker from 'material-ui/DatePicker';
import moment from 'moment';
import { DropDownSearch } from '../data-containers';
import { extractProperty } from '../../common/helpers';

const getFields = (hint, items, value, onChange, onKeyPress, changeToLabel) => {
    return {
        text: <TextField
            hintText={hint}
            value={value}
            onChange={onChange}
            onKeyPress={onKeyPress}
            fullWidth
        />,
        date: <DatePicker
            fullWidth
            floatingLabelFixed
            hintText=" / /"
            onChange={(event, newDate) => { onChange(event, newDate); changeToLabel(); }}
        />,
        select: <SelectField
            fullWidth
            value={value}
            onChange={(event, newSelected) => { onChange(event, newSelected); changeToLabel(); }}
        >
            <MenuItem value={'MXN'} primaryText="Pesos (MXN)" />
            <MenuItem value={'USD'} primaryText="Dolares (USD)" />
        </SelectField>,
        autocomplete: <DropDownSearch
            dataSource={extractProperty(items, 'name')}
        />
    };
};


class EditableInline extends Component {

    constructor(props) {
        super(props);
        this.state = {
            view: 'label',
            value: props.value
        };
    }

    render() {
        const { type, items = [], itemWasEdited = () => {} } = this.props;
        const { value, view } = this.state;
        const val = type === 'date' ? moment(value).format('DD-MM-YYYY') : value;
        return (
            <div
                onDoubleClick={() => {
                  this.setState({ view: 'edit' });
                  //this.props.itemWasEdited();
              }}
            >
                {
                    view === 'label' ?
                        <h5>{val || 'Sin Valor'}</h5> :
                        getFields(
                            'New Text',
                            items,
                            value,
                            (event, newValue) => this.setState({ value: newValue }),
                            (event) => {
                                if (event.charCode === 13) {
                                    event.preventDefault();
                                    //Validate before change state
                                    this.setState({ view: 'label' });
                                }
                            },
                            () => this.setState({ view: 'label' })
                        )[type]
                }
            </div>
        );
    }
}

EditableInline.defaultProps = {
    type: 'text'
};

export default EditableInline;



// WEBPACK FOOTER //
// ./components/text/editableInline.js